import type { SvelteDate } from 'svelte/reactivity';
import { employee, SchedularVehicle, SchedularVehicleAssignment, ScheduledJob } from './types';

export type DropPreview = {
    start: SvelteDate | null;
    end: SvelteDate | null;
    vehicle: SchedularVehicle | null;
    duration: number;
} | null;

type Dragging = {
    hoveringPos: {
        left: number;
        top: number;
        width: number;
        shiftX: number;
        shiftY: number;
    };
    dropPreview: DropPreview;
} & (
    | {
          type: 'pos';
          initialMouseX?: number;
          initialMouseY?: number;
          dragStarted?: boolean;
      }
    | {
          type: 'rightDur';
          startDragDur: number;
      }
    | {
          type: 'leftDur';
          endDate: SvelteDate;
          startDragLeftInitialClientX: number;
          startDragLeftDur: number;
          startDragLeftShift: number;
      }
);

export type PageStateAny = PageState<'job'> | PageState<'scheduledJob'> | PageState<'employee'> | PageState<null>;
export type PageStateSelected = PageState<'job'>;
export type PageState<T extends 'job' | 'scheduledJob' | 'employee' | null> = {
    searchStr: string;
    displayPopup: boolean;
    selected: T extends 'job'
        ? {
              type: 'job';
              item?: SchedularVehicleAssignment;
              absence: null;
              dragging: Dragging | null;
          }
        : T extends 'scheduledJob'
          ? {
                type: 'job';
                item: ScheduledJob;
                absence: null;
                dragging: Dragging | null;
            }
          : null;
    selectedEmployee: T extends 'employee'
        ? {
              type: 'employee';
              item: employee;
              absence: null;
              dragging: Dragging | null;
          }
        : null;
};

export function isStateScheduledJob(state: PageStateAny): state is PageState<'scheduledJob'> {
    return state.selected?.type === 'job' && state.selected.item?.start !== null;
}

export function isStateJob(state: PageStateAny): state is PageState<'job'> {
    return state.selected?.type === 'job';
}

// export function
// isStateEmployee(state: PageStateAny): state is PageState<"employee"> {
//     return state.selectedEmployee === "employee";
// }

export function isStateNull(state: PageStateAny): state is PageState<null> {
    return state.selected == null;
}
